var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutCreate',[_c('gdlFormDSL',{attrs:{"fields":_vm.fields,"action":_vm.actionCreateResource},on:{"cancel":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }